import { translations } from "./content/translations";
import { company } from "./company";

export const zipForm = (lang) => {
    return `
    <div class="dealer_search">
        <form id="zipCodeForm" class="row g-4">
            <div class="col-auto">
                <label for="zipCode" class="form-label">${translations.address[lang]}</label>
                <input type="text" class="form-control form-control-lg" id="zipCode">
            </div>
            <div class="col-auto">
                <label for="country" class="form-label">${translations.country[lang]}</label>
                <input type="text" class="form-control form-control-lg" id="country" placeholder="United States">
            </div>
            <div class="col-auto">
                <label for="distance" class="form-label">${translations.distance[lang]}</label>
                <input type="number" class="form-control form-control-lg" id="distance" placeholder="100">
            </div>
            <div class="col-auto dealer-buttons">
                <button id="getDealers" class="btn form-control-lg zip-button">${translations.showDealers[lang].toUpperCase()}</button>
                <button id="resetForm" class="btn form-control-lg zip-button">${translations.reset[lang].toUpperCase()}</button>
            </div>
        </form>
        <div id="liveAlertPlaceholder"></div>
    <div>
    `;
}

export const infoWindowContent = (dealer) => {
    return `
        <div class="dealer-map-info">
            ${dealer.display_name ? `<div class="dealer_name mb-1">${dealer.display_name}</div>` : ""}
            ${dealer.address ? `<div class="mb-1">${dealer.address.replace(", ,", ",")}</div>` : ""}
            ${dealer.phone ? `<div class="mb-1">${dealer.phone}</div>` : ""}
            ${dealer.email ? `<div class="mb-1"><a href="mailto:${dealer.email}">${dealer.email}</div>` : ""}
            ${dealer.website ? `<div><a href=${dealer.website} rel="noreferrer">${dealer.website}</a><div>` : ""}
        </div>
    `
}

export const becomeDealerForm = (lang) => {
    return `<div class="modal become-dealer_form" tabindex="-1">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">${translations.becomeDealerForm[lang].toUpperCase()}</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <form id="dealerRequest" method="post">
                    <div id="firstStep">
                        <input name="formName" value="Fast-Tube Dealer Request" type="hidden">
                        <div class="mb-3">
                            <label for="delaerInDeal" class="form-label" hidden>${translations.delaerInDeal[lang]}</label>
                            <input type="number" class="form-control" id="delaerInDeal" name="Years in business" placeholder='${translations.delaerInDeal[lang]}'>
                        </div>
                        <div class="mb-3">
                            <label for="dealerLocations" class="form-label" hidden>${translations.dealerLocations[lang]}</label>
                            <input type="number" class="form-control" id="dealerLocations" name="Number of locations" placeholder='${translations.dealerLocations[lang]}'>
                        </div>
                        <div class="mb-3">
                            <label for="dealerEmployees" class="form-label" hidden>${translations.dealerEmployees[lang]}</label>
                            <input type="number" class="form-control" id="dealerEmployees" name="Number of employees" placeholder='${translations.dealerEmployees[lang]}'>
                        </div>
                        <div class="mb-3">
                            <label for="dealerWarehouse" class="form-label" hidden>${translations.dealerWarehouse[lang]}</label>
                            <input type="number" class="form-control" id="dealerWarehouse" name="Size of warehouse" placeholder='${translations.dealerWarehouse[lang]}'>
                        </div>
                        <div class="mb-3">
                            <label for="dealerProducts" class="form-label" hidden>${translations.dealerProducts[lang]}</label>
                            <input type="text" class="form-control" id="dealerProducts" name="Other products" placeholder='${translations.dealerProducts[lang]}'>
                        </div>
                        <div class="mb-3">
                            <label for="dealerDiameter" class="form-label" hidden>${translations.dealerDiameter[lang]}</label>
                            <input type="text" class="form-control" id="dealerDiameter" name="Diameters" placeholder='${translations.dealerDiameter[lang]}'>
                        </div>
                        <div class="dealer-buttons_block">
                            <button type="button" class="btn btn-primary dealer-next">${translations.next[lang]}</button>
                        </div>
                    </div>
                    <div id="secondStep" class="hide_block">
                        <div class="mb-3">
                            <label for="delaerName" class="form-label" hidden>${translations.name[lang]}</label>
                            <input type="text" class="form-control" id="delaerName" name="Name" placeholder='${translations.name[lang]}'>
                        </div>
                        <div class="mb-3">
                            <label for="dealerCompany" class="form-label" hidden>${translations.company[lang]}</label>
                            <input type="text" class="form-control" id="dealerCompany" name="Company" placeholder='${translations.company[lang]}'>
                        </div>
                        <div class="mb-3">
                            <label for="dealerCity" class="form-label" hidden>${translations.city[lang]}</label>
                            <input type="text" class="form-control" id="dealerCity" name="City" placeholder='${translations.city[lang]}'>
                        </div>
                        <div class="mb-3">
                            <label for="dealerCountry" class="form-label" hidden>${translations.country[lang]}</label>
                            <input type="text" class="form-control" id="dealerCountry" name="Country" placeholder='${translations.country[lang]}'>
                        </div>
                        <div class="mb-3">
                            <label for="dealerPhone" class="form-label" hidden>${translations.phone[lang]}</label>
                            <input type="tel" class="form-control" id="dealerPhone" name="Phone" placeholder='${translations.phone[lang]}'>
                        </div>
                        <div class="mb-3">
                            <label for="dealerEmail" class="form-label" hidden>${translations.email[lang]}</label>
                            <input type="email" class="form-control" id="dealerEmail" name="Email" placeholder='${translations.email[lang]}'>
                        </div>
                        <div class="mb-3">
                            <label for="dealerWebsite" class="form-label" hidden>${translations.website[lang]}</label>
                            <input type="url" class="form-control" id="dealerWebsite" name="Website" placeholder='${translations.website[lang]}'>
                        </div>
                        <div class="mb-3">
                            <label for="dealerSocial" class="form-label" hidden>${translations.social[lang]}</label>
                            <input type="url" class="form-control" id="dealerSocial" name="Social" placeholder='${translations.social[lang]}'>
                        </div>
                        <div class="mb-3">
                            <label for="dealerInfo" class="form-label" hidden>${translations.dealerInfo[lang]}</label>
                            <textarea class="form-control" id="dealerInfo" name="Message" placeholder='${translations.dealerInfo[lang]}'></textarea>
                        </div>
                        <div class="dealer-buttons_block">
                            <button type="button" class="btn btn-primary dealer-previous">${translations.previous[lang]}</button>
                            <button type="submit" id="becomeDealerButton" class="btn btn-primary dealer-submit">${translations.submit[lang]}</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>`}

export const reportTemplate = (data) => {
    const lang = 'en'
    return `
            <div class="mt-3 mx-5 text-center pdf-body">
                <div class="mb-5">
                    <div><img style="width: 500px;" src="../images/fab-form-logo.webp"></div>
                </div>
                <div class="mb-5">
                    <div class="mb-2"><h3>Fast-Tube Estimator Request</h3></div>
                    <div id="pdfTable" style="font-size: 9px">
                        <div class="mb-2">    
                            <table>
                                <tbody>
                                    <tr>
                                        <td>${translations.columnHeight[lang]}</td>
                                        <td>${translations.diameter[lang]}</td>
                                        <td>${translations.labourCostPerHour[lang]}</td>
                                        <td>${translations.numberOfColumns[lang]}</td>
                                        <td>${translations.cardboardLength[lang]}</td>
                                        <td>${translations.cardboardPrice[lang]}</td>
                                        <td>${translations.shippingCost[lang]}</td>
                                    </tr>
                                    <tr>
                                        <td>${data.diameter}</td>
                                        <td>${data.columnHeight}</td>
                                        <td>${data.labourCost}</td>
                                        <td>${data.columns}</td>
                                        <td>${data.cardboardLenght}</td>
                                        <td>${data.cardboardPrice}</td>
                                        <td>${data.shippingCost}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div>
                            <table>
                                <tbody>
                                    <tr>
                                        <td></td>
                                        <td colspan="3"><strong>Cardbord tube</strong></td>
                                        <td colspan="3"><strong>FAST-TUBE</strong></td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td>${translations.cost[lang]}</td>
                                        <td>${translations.qty[lang]}</td>
                                        <td>$</td>
                                        <td>${translations.cost[lang]}</td>
                                        <td>${translations.qty[lang]}</td>
                                        <td>$</td>
                                    </tr>
                                    <tr>
                                        <td>${translations.columnForm[lang]}</td>
                                        <td>${data.cardboardPrice}</td>
                                        <td>${data.stColumnQtyCalc}</td>
                                        <td>${data.stColumnTotalCalc}</td>
                                        <td>${data.ftColumnCostCalc}</td>
                                        <td>${data.ftColumnQtyCalc}</td>
                                        <td>${data.ftColumnTotalCalc}</td>
                                    </tr>
                                    <tr>
                                        <td>${translations.shipping[lang]}</td>
                                        <td>${data.shippingCost}</td>
                                        <td>${data.stShippingQtyCalc}</td>
                                        <td>${data.stColumnTotalCalc}</td>
                                        <td>${data.shippingCost}</td>
                                        <td>${data.ftShippingQtyCalc}</td>
                                        <td>${data.ftShippingTotalCalc}</td>
                                    </tr>
                                    <tr>
                                        <td>${translations.strippingLabor[lang]}</td>
                                        <td>${data.labourCost}</td>
                                        <td>${data.columns}</td>
                                        <td>${data.stLaborTotalCalc}</td>
                                        <td>${data.ftLaborCostCalc}</td>
                                        <td>${data.columns}</td>
                                        <td>${data.ftLaborTotalCalc}</td>
                                    </tr>
                                    <tr>
                                        <td>${translations.total[lang].toUpperCase()}</td>
                                        <td colspan="3">${data.stTotalCost}</td>
                                        <td colspan="3">${data.ftTotalCost}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div id="pdfTable" class="mb-5" style="font-size: 11px">
                    <div><h3>Quotation</h3></div>
                    <table>
                        <thead>
                            <tr>
                                <td>Fast-Tube Size</td>
                                <td>Qty</td>
                                <td>Price</td>
                                <td>Total</td>
                            </tr>
                        </thead>
                        <tbody>
                            <td>FT-${data.diameter} 100'</td>
                            <td>${Math.ceil(data.ftColumnQtyCalc / 100)}</td>
                            <td>${data.ftPrice * 100}</td>
                            <td>$${Math.ceil(data.ftColumnQtyCalc / 100) * data.ftPrice * 100}</td>
                        </tbody>
                    </table>
                </div>
                <div class="pdf-footer">
                    <div>
                        <div class="d-inline-flex">
                            <div>${translations.emailUs[lang]}:</div>
                            <div><a href=${company.email}>${company.email}</a></div>
                        </div>
                    </div>
                    <div>
                        <div class="d-inline-flex">
                            <div>${translations.callUs[lang]}:</div>
                            <div>${company.phone}</div>
                        </div>
                    </div>
                    <div>
                        <div class="d-inline-flex">
                            <div>${translations.address[lang]}: </div>
                            <div>#19, 1610 Derwent Way, Delta BC V3M 6W1</div>
                        </div>
                    </div>
                    <div>
                        <div class="pdf-social-link">https://shop.fab-form.com/</div>
                        <div class="pdf-social-link">https://www.instagram.com/fabformindustries</div>
                        <div class="pdf-social-link">https://www.youtube.com/@FabFormIndustries</div>
                        <div class="pdf-social-link">https://www.facebook.com/FabFormIndustries</div>    
                    </div>
                </div>
            </div>
    `
}

export const createGreetingBlock = (item) => {
    return `
        <div class="greeting_wrap">
            <div class="greeting_image_wrap">
                <img src=${item.greeting.image} alt="Greeting Image" />
                <div class="greeting_image_text">
                    <div class="greeting_image_title">${item.greeting.imageTitle}</div>
                    <div class="greeting_image_desc">${item.greeting.imageDesc}</div>
                    <div class="greeting_image_sign">${item.greeting.imageSign}</div>
                </div>
            </div>
            <div class="greeting_text_wrap">
                <div class="greeting_text_block">
                    <div class="title-wrap">
                        <div class="page_title grey-color">${item.greeting.title}</div>
                        <div class="menu-item-underline"></div>
                    </div>
                    <div class="greeting_body_title">${item.greeting.bodyTitle}</div>
                    <div>${item.greeting.body}</div>
                </div>
                <div class="greeting_contactUs_wrap">
                    <div class="greeting_contactUs_text">${item.greeting.contactUsText}</div>
                    <div class="greeting_contactUs_button" onclick="window.open('/contact-us')">REQUEST A QUOTE</div>
                </div>
            </div>
        </div>
    `
}

export const createProductListItem = (element, lang) => {
    return `<li class="header_productItem">
        <div class="header_product_overlay"></div>
        <img class="header_productImage" src="${element.image}" alt="${element.title }" />
        
        <div class="header_productTitle_wrap">
            <div class="header_productTitle">${element.menuItem[lang].title.toUpperCase()}</div>
            <div class="header_productUnderTitle">${element.menuItem[lang].underTitle}</div>
        </div>
        
        <div class="header_productDescription_wrap">
            <div class="header_productDescription">${element.menuItem[lang].shortDescription}</div>
        </div>
    </li>`;
}

export const footerBlock = `
        <div class="footer_wrap">
            <div class="footer_block">
                <div class="footer_info_block">
                    <div class="footer_line"></div>
                    <div class="footer_info_title">CONTACT INFO</div>
                    <div class="footer_store">
                    <div class="footer_store_icon"></div>
                        <div>
                            <div class="footer_store_title">Fab-Form Store</div>
                            <div class="footer_store_text"><a id="storeButton" href="${company.shop}shop" target="_blank">${company.shop}</a></div>
                        </div>
                    </div>
                    <div class="footer_email">
                        <div class="footer_email_icon"></div>
                        <div>
                            <div class="footer_email_title">Email us</div>
                            <div class="footer_email_text"><a href="mailto:info@fab-form.com">info@fab-form.com</a></div>
                        </div>
                    </div>
                    <div class="footer_phone">
                        <div class="footer_phone_icon"></div>
                        <div>
                            <div class="footer_phone_title">Call us</div>
                            <div class="footer_phone_text"><a href="tel:+18883033278">888-303-3278</a></div>
                        </div>
                    </div>
                    <div class="footer_address">
                        <div class="footer_address_icon"></div>
                        <div>
                            <div class="footer_address_title">Address</div>
                            <div class="footer_address_text"><a href="https://maps.app.goo.gl/L12rLNyaTWQGeNXJ6" target="_blank">#19, 1610 Derwent Way, Delta BC V3M 6W1</a></div>
                        </div>
                    </div>
                    <div class="footer_workdays">
                        <div class="footer_workdays_icon"></div>
                        <div>
                            <div class="footer_workdays_title">Opening Hours</div>
                            <div class="footer_workdays_text">Mon–Fri: 8 AM – 6 PM PST (11 AM - 9 PM EST)</div>
                        </div>
                    </div>
                    <div class="footer_social">
                        <div class="footer_social_icon"></div>
                        <div>
                            <div class="footer_social_title">Social Media</div>
                            <div class="footer_social_list">
                                <a id="openInstagramButton" href="https://www.instagram.com/fabformindustries" aria-label="Fab-Form Industiries on Instagram" target="_blank"><div id="openInstagramButton" class="footer_social_instagram"></div></a>
                                <a id="openYouTubeButton" href="https://www.youtube.com/@FabFormIndustries" aria-label="Fab-Form Industiries on Youtube" target="_blank"><div id="openYouTubeButton" class="footer_social_youtube"></div></a>
                                <a id="openFacebookButton" href="https://www.facebook.com/FabFormIndustries" aria-label="Fab-Form Industiries on Facebook" target="_blank"><div id="openFacebookButton" class="footer_social_facebook"></div></a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="footer_contact_block">
                    <div class="footer_line"></div>
                    <div class="footer_contact_title">CONTACT US</div>
                    <div class="footer-form-wrapper">
                        <form id="contactUs" data-static-form-name="contact" method="post">
                            <div>
                                <input type="hidden" name="formName" value="Contact Form" />
                                <input type="text" name="Name" placeholder="Name" required="">
                                <input type="text" name="Company" placeholder="Company">
                                <input type="text" name="Country" placeholder="Country">
                                <input type="tel" name="Phone" placeholder="Phone" required="">
                                <input type="email" name="Email" placeholder="Email" required="">
                            </div>
                            <div>
                                <textarea id="message" name="message" placeholder="Your message" required=""></textarea>
                                <button type="submit" class="button">Send</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>`;

export const investorSubscribe = () => {
    return `
        <div class="container py-5">
            <div id="step1">
                <div class="card standard-background">
                    <div class="card-body">
                        <form id="stepOne">
                            <label for="emailInput" class="form-label">Email address</label>
                            <div class="input-group mb-3">
                                <input
                                    type="email"
                                    name="email"
                                    class="form-control email-input"
                                    id="emailInput"
                                    placeholder="you@example.com"
                                    required
                                />
                                <button class="btn btn-warning" id="sendCodeBtn" type="button">Send Code</button>
                            </div>
                            <p>Subscribe to our Investor Updates and receive the latest company news, financial reports, and investment announcements directly in your inbox. Stay informed and connected to our journey.</p>
                        </form>
                    </div>
                </div>
            </div>
            <div id="step2">
                <div class="card standard-background">
                    <div class="card-body">
                        <form id="stepTwo">
                            <label for="emailDisplay" class="form-label">Please check your inbox and enter the code below to continue</label>
                            <div class="input-group mb-3">
                                <input
                                    type="email"
                                    name="email"
                                    class="form-control email-input"
                                    id="emailDisplay"
                                    readonly
                                />
                                <button id="changeEmailBtn" class="btn btn-light">Change Email</button>
                            </div>
                            <label for="codeInput" class="form-label">Verification Code</label>
                            <div class="input-group">
                                <input
                                    type="text"
                                    name="code"
                                    class="form-control code-input"
                                    id="codeInput"
                                    placeholder="123456"
                                    required
                                />
                                <button id="verifyCodeBtn" class="btn btn-success">Verify Code</button>
                                <button id="resendBtn" class="btn btn-outline-secondary" disabled>Resend <span id="timerWrapper">(<span id="timer">30</span>s)</span></button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div id="step3">
                <div class="card standard-background">
                    <div class="card-body">
                        <form id="stepThree">
                            <h5>Please select the appropriate contact from the list below and proceed</h5>
                            <div id="contactsContainer" class="mb-3"></div>
                            <button type="submit" id="investorSubscription" class="btn btn-primary ft-button">Subscribe</button>
                        </form>
                    </div>
                </div>
            </div>
            <div id="step4">
                <div class="card standard-background">
                    <div class="card-body">
                        <form id="investorSubmit">
                            <div class="row d-flex flex-wrap">
                                <div class="col-md-4 mb-3">
                                    <label for="fullName" class="form-label">First and Last Name</label>
                                    <input type="text" class="form-control" id="fullName" name="fullName" required>
                                </div>
                                <div class="col-md-4 mb-3">
                                    <label for="email" class="form-label">Email</label>
                                    <input type="email" class="form-control" id="email" name="email" required>
                                </div>
                                <div class="col-md-4 mb-3">
                                    <label for="phone" class="form-label">Phone</label>
                                    <input type="tel" class="form-control" id="phone" name="phone">
                                </div>
                            </div>
                            <div class="row d-flex flex-wrap">
                                <div class="col-md-6 mb-3">
                                    <label for="address" class="form-label">Address</label>
                                    <input type="text" class="form-control" id="address" name="address">
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label for="city" class="form-label">City</label>
                                    <input type="text" class="form-control" id="city" name="city">
                                </div>
                            </div>
                            <div class="row d-flex flex-wrap">
                                <div class="col-md-4 mb-3">
                                    <label for="state" class="form-label">State/Province</label>
                                    <input type="text" class="form-control" id="state" name="state">
                                </div>
                                <div class="col-md-4 mb-3">
                                    <label for="postalCode" class="form-label">Postal Code</label>
                                    <input type="text" class="form-control" id="postalCode" name="postalCode">
                                </div>
                                <div class="col-md-4 mb-3">
                                    <label for="country" class="form-label">Country</label>
                                    <input type="text" class="form-control" id="country" name="country" required>
                                </div>
                            </div>
                            <fieldset class="mb-4">
                                <legend class="col-form-label pt-0">Existing Shareholder</legend>
                                <div class="form-check">
                                    <input class="form-check-input" type="radio" name="isShareholder" id="shareholderYes" value="yes">
                                    <label class="form-check-label" for="shareholderYes">Yes</label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" type="radio" name="isShareholder" id="shareholderNo" value="no" checked>
                                    <label class="form-check-label" for="shareholderNo">No</label>
                                </div>
                            </fieldset>
                            <button type="submit" id="investorSubmission" class="btn btn-primary ft-button">Submit</button>
                        </form>
                    </div>
                </div>
            </div>
        </div>`;
}
